<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body px-3 pt-0 pb-2 min-vh-50">
              <form id="search" class="mt-3" @submit.prevent="getEvaluation">
                <div class="row g-2 d-flex justify-content-end">
                  <div class="col-12 col-sm-3">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">Month</label>
                    <Datepicker 
                      v-model="search.month" 
                      range
                      monthPicker
                      format="MMMM yyyy"
                      placeholder="Select month"
                      />
                  </div>
                  <div class="col-12 col-sm-1 align-self-top pt-4">
                    <button type="submit" class="btn btn-primary mb-0 justify-content-center" style="width: 50px;" @click="resetOffset">
                      <i class="fa fa-search"></i>
                    </button>

                    <!-- Adding margin to create space -->
                    <button class="btn btn-primary mb-0 justify-content-center" style="width: 50px; margin-left: 5px;" @click="clearSearch">
                      <i class="fa fa-times-circle"></i>
                    </button>

                  </div>
                </div>
              </form>
              <hr class="my-2"/>
              <div class="d-flex justify-content-end">
                <!-- <button class="btn btn-xs btn-outline-primary"><i class="fa fa-download"></i> Download</button> -->
                <div class="d-flex">
                  <p class="align-self-center text-xs text-secondary">{{ current_page }} - {{ current_total_data }} / {{ total_data }}</p>
                  <argon-pagination color="gradient-primary" size="sm">
                    <argon-pagination-item
                    @click="prevPage"
                      prev
                      :disabled="offset === 0 ? true : false" />
                    <argon-pagination-item
                      @click="nextPage"
                      next
                      :disabled="record_more === false ? true : false" />
                  </argon-pagination>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-hover align-items-center">
                    <thead>
                        <tr class="bg-light">
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Number</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Production Month</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Average Points</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Score Rate</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Description</th>
                            <!-- <th class="text-uppercase text-xxs font-weight-bolder" colspan="2">Range</th> -->
                        </tr>
                    </thead>
                  <tbody>
                    <tr v-for="(performance, i) in performances" :key="i">
                      <td>
                        <router-link :to="'/vendor-performance/' + performance.id" class="text-xs text-primary font-weight-bold mb-0">
                            {{ performance.name }}
                          </router-link>
                      </td>
                      <td>
                        <p class="mb-0 text-xs">{{ performance.month }} {{ performance.year }}</p>
                      </td>
                      <td>
                        <p class="mb-0 text-xs">{{ performance.summary_average }}</p>
                      </td>
                      <td class="text-xs">
                        <p class="mb-0 text-xs">{{ performance.summary_score_rate }}</p>
                      </td>
                      <td class="text-xs">
                        <p class="mb-0 text-xs">{{ performance.summary_description }}</p>
                      </td>
                      <!-- <td class="text-xs align-middle">
                        <div>
                          <i class="ni ni-bold-up text-xxs text-success" v-if="performance.state == 'up'"></i>
                          <i class="ni ni-bold-down text-xxs text-danger" v-if="performance.state == 'down'"></i>
                          <i class="ni ni-fat-delete text-xxs text-muted" v-if="performance.state == 'same'"></i>
                        </div>
                      </td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
              <empty-state v-if="!performances.length > 0 && !loading"/>
              <loading-state v-if="loading"/>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import EmptyState from "./components/EmptyState.vue";
import LoadingState from "./components/LoadingState.vue";
const endpoint = require("../router/endpoint");
export default {
  name: "RFQ",
  components: {
    ArgonPagination,
    ArgonPaginationItem,
    EmptyState,
    LoadingState
  },
  data() {
    return {
      loading: false,
      total_data: 0,
      current_total_data: 0,
      current_page: 0,
      offset: 0,
      record_more: false,
      search: {
        number: null,
        month: null
      },
      performances: []
    };
  },
  methods: {
    prevPage() {
      if (this.offset > 0) {
          this.offset = this.offset - 10
          this.getEvaluation()
        }
      },
    nextPage() {
      if (this.record_more === true) {
        this.offset = this.offset + 10
        this.getEvaluation()
      }
    },
    getDate(daterange) {
      var dateList = []
      if (daterange !== null){
        if (daterange.length > 0) {
          daterange.forEach(date => {
            if (date !== null) {
              let month = date.month >= 9 ? (date.month + 1) : '0' + (date.month + 1)
              let fullDate = date.year + '-' + month + '-' + '01'
              dateList.push(fullDate)
            }
          });
        }
      }
      return dateList
    },
    getEvaluation() {
      this.performances = []
      this.loading = true
      this.total_data = 0
      this.current_total_data = 0
      this.record_more = false
      this.current_page = 0
      const getMonthrange = this.getDate(this.search.month)
      const values = {
        partner_id: localStorage.getItem('partner_id'),
        start_date: getMonthrange.length > 0 ? getMonthrange[0] : null,
        end_date: getMonthrange.length > 1 ? getMonthrange[1] : null,
        evaluation_number: null,
        limit: 10,
        offset: this.offset
      }
      this.axios
        .post(
          endpoint.EVALUATION_LIST,
          values,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.performances = response.data.data;
            this.total_data = response.data.total_data
            this.current_total_data = response.data.current_total_data
            this.record_more = response.data.record_more
            this.current_page = response.data.current_page
          } else {
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'warn',
                title: 'Warning',
                text: response.data.message,
              });
            }
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false;
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message,
            });
        });
    },
    clearSearch(){
          this.search.number = null;
          this.search.month = null;
    }
  },
  mounted() {
    this.getEvaluation()
  }
};
</script>

<style>

</style>